import { render, staticRenderFns } from "./jd-file-upload.vue?vue&type=template&id=3c0ca8d8&scoped=true&"
import script from "./jd-file-upload.vue?vue&type=script&lang=js&"
export * from "./jd-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./jd-file-upload.vue?vue&type=style&index=0&id=3c0ca8d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0ca8d8",
  null
  
)

export default component.exports